import React, { useState, useEffect } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { useContext } from "react";
import NavLinkContext from "../../context/NavLinkContext";

// assets
import navLogo from "../../assets/images/StratCap-DIR-Logo-Reversed.png";

// css
import "./MegaMenu.css";

const MegaMenu = () => {
  const { navLinkColor, setNavLinkColor } = useContext(NavLinkContext);
  // state objects
  const [mainOpen, setMainOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  const menuGrid = () => {
    return (
      <div className="menu-grid">
        <div className="menu-grid-column">
          <ul className="nav-ul">
            <li>
              <NavLink
                to="/"
                activeClassName="selected"
                scroll={(el) => scrollWithOffset(el)}
                onClick={() => {
                  setMainOpen(false);
                  setIsChecked(false);
                  setNavLinkColor("home");
                }}
                className={`${
                  navLinkColor === "home"
                    ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                    : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                }`}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/investments"
                activeClassName="selected"
                scroll={(el) => scrollWithOffset(el)}
                onClick={() => {
                  setMainOpen(false);
                  setIsChecked(false);
                  setNavLinkColor("investments");
                }}
                className={`${
                  navLinkColor === "investments"
                    ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                    : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                }`}
              >
                Investments
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/performance"
                activeClassName="selected"
                scroll={(el) => scrollWithOffset(el)}
                onClick={() => {
                  setMainOpen(false);
                  setIsChecked(false);
                  setNavLinkColor("performance");
                }}
                className={`${
                  navLinkColor === "performance"
                    ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                    : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                }`}
              >
                Performance
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/offeringdetails"
                activeClassName="selected"
                scroll={(el) => scrollWithOffset(el)}
                onClick={() => {
                  setMainOpen(false);
                  setIsChecked(false);
                  setNavLinkColor("offeringdetails");
                }}
                className={`${
                  navLinkColor === "offeringdetails"
                    ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                    : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                }`}
              >
                Offering Details
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/team"
                activeClassName="selected"
                scroll={(el) => scrollWithOffset(el)}
                onClick={() => {
                  setMainOpen(false);
                  setIsChecked(false);
                  setNavLinkColor("team");
                }}
                className={`${
                  navLinkColor === "team"
                    ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                    : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                }`}
              >
                Team
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/literature"
                activeClassName="selected"
                scroll={(el) => scrollWithOffset(el)}
                onClick={() => {
                  setMainOpen(false);
                  setIsChecked(false);
                  setNavLinkColor("literature");
                }}
                className={`${
                  navLinkColor === "literature"
                    ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                    : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                }`}
              >
                Literature
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/investorrelations"
                activeClassName="selected"
                scroll={(el) => scrollWithOffset(el)}
                onClick={() => {
                  setMainOpen(false);
                  setIsChecked(false);
                  setNavLinkColor("investorrelations");
                }}
                className={`${
                  navLinkColor === "investorrelations"
                    ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                    : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                }`}
              >
                Investor Relations
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="nav-wrapper h-[83px] bg-hmcNavBg text-white fixed z-[9999] w-full flex content-center drop-shadow-sm">
        <div className="flex items-center">
          <Link
            to="/"
            className="nav-icon"
            onClick={() => {
              setMainOpen(false);
              setIsChecked(false);
              scrollTop();
            }}
          >
            <img src={navLogo} alt="nav logo" className="pl-2" />
          </Link>
        </div>
        <input
          className="menu-btn"
          type="checkbox"
          id="menu-btn"
          name="menu-btn"
          checked={isChecked}
        />
        <label
          className="menu-icon"
          for="menu-btn"
          onClick={() => {
            setMainOpen(!mainOpen);
            setIsChecked(!isChecked);
          }}
        >
          <span className="navicon" aria-label="Hamburger menu 'icon'" />
        </label>
      </div>
      <div
        className={
          mainOpen ? "nav-dropdown-main-show" : "nav-dropdown-main-hide"
        }
      >
        <div className="nav-dropdown bg-black p-5 w-full fixed">
          {menuGrid()}
        </div>
        {/* <div className="nav-dropdown">{collapsableMen()}</div> */}
      </div>
    </>
  );
};

export default MegaMenu;
